/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consult_Purchase_MailInputs */

const en_consult_purchase_mail = /** @type {(inputs: Consult_Purchase_MailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open email draft`)
};

const id_consult_purchase_mail = /** @type {(inputs: Consult_Purchase_MailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buka draf email`)
};

/**
* | output |
* | --- |
* | "Open email draft" |
*
* @param {Consult_Purchase_MailInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const consult_purchase_mail = /** @type {((inputs?: Consult_Purchase_MailInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consult_Purchase_MailInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_consult_purchase_mail(inputs)
	return en_consult_purchase_mail(inputs)
});